import { IDataTableOptionalProps } from '../../DataTable/common/defaults';
import {
  FormElementConfig,
  IFormElementConfig,
} from '../../DualValueFormElement/assets/BusinessObjects';
import { eFormElementType } from '../../../services/Enums/shared';
import Moment from 'moment';

export const checkersQueueColumns = [
  {
    title: 'Actions',
    data: 'workflowItem.report.crashReportId',
  },
  {
    title: 'Crash Key',
    data: 'workflowItem.report.keywords.originalCrashKey',
  },
  {
    title: 'Date Of Crash',
    mData: function (data, type, dataToSet) {
      return Moment(data.workflowItem.report.keywords.dateOfCrash);
    },
  },
  {
    title: 'County',
    mData: function (data, type, dataToSet) {
      return data?.workflowItem?.report?.keywords?.county != null
          ? data.workflowItem.report.keywords.county.description
          : '';
    },
  },
  {
    title: 'Document Id',
    data: 'workflowItem.report.keywords.documentId',
  },
  {
    title: 'Assigned To',
    mData: function (data, type, dataToSet) {
      return data.user != null ? data.user.username : '';
    },
  },
  {
    title: 'Workflow Status',
    mData: function (data, type, dataToSet) {
      return data.workflowStepStatus != null
          ? data.workflowStepStatus.name
          : 'Status Indeterminable';
    },
    className: 'workflowStepStatus',
  },
  {
    title: 'Priority',
    data: 'workflowItem.report.keywords.priorityName',
  },
  {
    title: 'hidden',
    data: 'workflowItem.report.keywords.priorityNumber',
  },
];

export const checkersQueueOptions = {
  className: 'table table-striped table-bordered',
  select: false,
  orderFixed: {
    pre: [8, 'asc'],
  },
};

export const checkersCrashConfig: IFormElementConfig[] = [
  new FormElementConfig(
    'Crash City',
    true,
    'crashCityOrPlace',
    eFormElementType.Dropdown,
    [],
    'City'
  ),
  new FormElementConfig(
    'Time of Roadway Clearance',
    true,
    'timeOfRoadwayClearance',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig('Property', true, 'property', eFormElementType.Textbox,
  [],),
  new FormElementConfig(
    'DMV Exclusion Code',
    true,
    'dmvExclusionCode',
    eFormElementType.Textbox,
    [],
  ),
];

export const checkersVehicleConfig: IFormElementConfig[] = [
  new FormElementConfig(
    'VehicleNumber',
    true,
    'vehicleNumber',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Motor Vehicle Unit Type',
    true,
    'motorVehicleUnitType',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Vehicle Owner Name',
    true,
    'vehicleOwnerName',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'License Plate Number',
    true,
    'licensePlateNumber',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'License Plate State',
    true,
    'licensePlateState',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'License Plate Registration Year',
    true,
    'licensePlateRegistrationYear',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Vehicle Make',
    true,
    'vehicleMake',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Vehicle Model',
    true,
    'vehicleModel',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Vehicle Model Year',
    true,
    'vehicleModelYear',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Plate Type',
    true,
    'plateType',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'VIN',
    true,
    'vehicleIdentificationNumber',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Vehicle Damage Estimate',
    true,
    'vehicleDamageEstimate',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Commercial Truck / Bus CarrierName',
    true,
    'commercialTruckBusCarrierName',
    eFormElementType.Textbox,
    [],
  ),
];

export const checkersPeopleConfig: IFormElementConfig[] = [
  new FormElementConfig(
    'Involved Person Name',
    true,
    'name',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Date of Birth',
    true,
    'dateOfBirth',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Drivers License Number',
    true,
    'driversLicenseNumber',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig(
    'Drivers License State',
    true,
    'driversLicenseState',
    eFormElementType.Textbox,
    [],
  ),
  new FormElementConfig('Injury', true, 'injury', eFormElementType.Textbox,
  [],),
  new FormElementConfig(
    'Non Motorist Number',
    true,
    'nonMotoristNumber',
    eFormElementType.Textbox,
    [],
  ),
];

interface IInternalCrashDataCorrection {
  crashId: number;
  streetName?: string;
  nameOfIntersectingRoadway?: string;
  ownership?: string;
  crashClassification?: string;
  countyName?: string;
  cityName?: string;
  firstHarmfulEvent?: string;
  locationOfFirstHarmfulEvent?: string;
  mannerOfCrash?: string;
  withinInterchangeArea?: string;
  numberOfApproaches?: string;
  overallIntersectionGeometry?: string;
  overallTrafficControlDevice?: string;
  railwayCrossingId?: string;
  directionOfTravelBeforeCrash?: string;
  maneuver?: string;
  lastModifiedByUserId?: number;
}

export class InternalCrashDataCorrection
  implements IInternalCrashDataCorrection {
  constructor(
    public crashId: number,
    public streetName?: string,
    public nameOfIntersectingRoadway?: string,
    public ownership?: string,
    public crashClassification?: string,
    public countyName?: string,
    public cityName?: string,
    public firstHarmfulEvent?: string,
    public locationOfFirstHarmfulEvent?: string,
    public mannerOfCrash?: string,
    public withinInterchangeArea?: string,
    public numberOfApproaches?: string,
    public overallIntersectionGeometry?: string,
    public overallTrafficControlDevice?: string,
    public railwayCrossingId?: string,
    public directionOfTravelBeforeCrash?: string,
    public maneuver?: string,
    public lastModifiedByUserId?: number
  ) {}
}
